import { makeStyles } from "@fluentui/react-components";
import { projectIqTokens } from "apps/project-iq/theme/projectIqTokens";
import { designTokens } from "theme/customTheme";

export const useManageIqNotificationsStyles = makeStyles({
  dialogField: {
    marginBottom: designTokens.spacing[3],
  },
  errorAlert: {
    color: projectIqTokens.rust,
    fontSize: designTokens.fontSize.sm,
    marginBottom: designTokens.spacing[2],
  },
  pillInformational: {
    background: projectIqTokens.tealSoft,
    color: projectIqTokens.tealInk,
    borderRadius: designTokens.borderRadius.lg,
    padding: "2px 8px",
    fontSize: designTokens.fontSize.xs,
    fontWeight: designTokens.fontWeight.semibold,
  },
  pillWarning: {
    background: designTokens.semantic.warningLight,
    color: designTokens.semantic.warningDark,
    borderRadius: designTokens.borderRadius.lg,
    padding: "2px 8px",
    fontSize: designTokens.fontSize.xs,
    fontWeight: designTokens.fontWeight.semibold,
    border: `1px solid ${projectIqTokens.amber}`,
  },
  titleCell: {
    fontWeight: designTokens.fontWeight.semibold,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    display: "block",
  },
  cellEnabled: {
    color: designTokens.semantic.success,
    fontWeight: designTokens.fontWeight.medium,
    fontSize: designTokens.fontSize.sm,
  },
  cellDisabled: {
    color: designTokens.neutral[400],
    fontWeight: designTokens.fontWeight.medium,
    fontSize: designTokens.fontSize.sm,
  },
  authorCell: {
    color: designTokens.neutral[500],
    fontSize: designTokens.fontSize.sm,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    display: "block",
  },
});
